<ui-simple-dialog-layout (clickCancel)="clickCancel.emit()">
  <span slot="title">{{ 'cockpit.documents.shareDialog.title' | transloco }}</span>

  @if (!shareLink.isLoading() && shareLink.error()) {
    <app-error-component class="block" [enableRetry]="true" (clickRetry)="shareLink.reload()" />
  } @else {
    <div class="flex flex-col gap-6">
      @if (shareLink.isLoading()) {
        <ui-input-label>
          <ui-skeleton class="block h-6 w-25 rounded-full" />
          <ui-skeleton slot="input" class="block h-10 w-full rounded-md" />
        </ui-input-label>
      } @else if (shareLink.hasValue()) {
        <ui-input-label>
          {{ 'cockpit.documents.shareDialog.shareLinkLabel' | transloco }}
          <ui-input-simple [value]="shareLink.value().url">
            <ui-button
              slot="end"
              type="button"
              [iconOnly]="true"
              [style.--ui-button-border-radius]="'0px var(--radius-md) var(--radius-md) 0px'"
              aria-label="{{ 'cockpit.documents.shareDialog.copyLinkAriaLabel' | transloco }}"
              mode="outlined"
              (click)="copyLink()"
              class="ml-0.5 -mr-3"
            >
              @switch (copyState()) {
                @case ('loading') {
                  <ui-loading-spinner size="20" />
                }
                @case ('success') {
                  <ng-icon name="heroCheck" size="20" class="!block" />
                }
                @case ('error') {
                  <ng-icon name="heroXMark" size="20" class="!block" />
                }
                @default {
                  <ng-icon name="heroDocumentDuplicate" size="20" class="!block" />
                }
              }
            </ui-button>
          </ui-input-simple>
        </ui-input-label>
      }

      <ui-toggle-label alignToggle="TOP">
        <ui-toggle [formField]="form.customExpiry" />
        <div class="flex flex-col">
          <span class="text-sm font-normal">
            {{ 'cockpit.documents.shareDialog.customExpiry' | transloco }}
          </span>
          <span
            class="text-xs font-normal text-on-surface-variant dark:text-on-surface-variant-darkmode flex gap-0.5 items-center"
          >
            @if (form.customExpiry().value()) {
              {{ 'cockpit.documents.shareDialog.validUntil' | transloco }}
            } @else {
              {{ 'cockpit.documents.shareDialog.defaultExpiry' | transloco }}
            }
            @if (shareLink.value()?.expiresAt; as expiresAt) {
              {{ expiresAt | date: 'dd.MM.yyyy HH:mm' }}
            } @else {
              <ui-skeleton class="inline-block h-4 w-25 rounded-full" />
            }
          </span>
        </div>
      </ui-toggle-label>

      <ui-input-label [class.hidden]="!form.customExpiry().value()">
        {{ 'cockpit.documents.shareDialog.changeValidity' | transloco }}
        <ui-select [formField]="form.expiryMinutes">
          <option value="1440" [selected]="form.expiryMinutes().value() === '1440'">
            {{ 'cockpit.documents.shareDialog.expiryOptions.hours24' | transloco }}
          </option>
          <option value="10080" [selected]="form.expiryMinutes().value() === '10080'">
            {{ 'cockpit.documents.shareDialog.expiryOptions.days7' | transloco }}
          </option>
          <option value="20160" [selected]="form.expiryMinutes().value() === '20160'">
            {{ 'cockpit.documents.shareDialog.expiryOptions.days14' | transloco }}
          </option>
          <option value="43200" [selected]="form.expiryMinutes().value() === '43200'">
            {{ 'cockpit.documents.shareDialog.expiryOptions.days30' | transloco }}
          </option>
        </ui-select>
      </ui-input-label>
    </div>
  }

  <ui-button slot="footer" mode="outlined" type="button" (click)="clickCancel.emit()">
    {{ 'cockpit.documents.shareDialog.closeButton' | transloco }}
  </ui-button>
</ui-simple-dialog-layout>
